// Rollup will load this config when running a build (not a run dev)
// It will apply to all cloud environments (devsgp01, alpha and prod)
export default {
    apiUrl: '',
    debug: false,
    recaptch_key: '6LfTyTEqAAAAAJHcH2QskwOEi6jjEDMu-dkP-BYd'
}